
import Vue from "vue";
import { Contact } from "@/models/base";
import {UserConfigService} from "@/services";

export default Vue.extend({
	data(){
		return {
			text: ""
		};
	},
	props: {
		contact: {type: Object as () => Contact},
	},
	computed: {
		showEditor():Boolean {
			return (UserConfigService.getSaleSettings().DescriptionEditor);
		},
	},
	watch: {
		"text": {
			immediate: true,
			handler(){
				console.log("Let's go");
				if(!this.contact.Info.includes("{__NEW_LINE__}")) {
					if(this.showEditor){
						this.contact.Info = this.contact.Info.replace(/(?:\r\n|\r|\n)/g, "<br>");
						this.text = this.contact.Info;
					}else{
						this.text = this.contact.Info.replace(/(?:\r\n|\r|\n)/g, "\n");
					}
				}else{
					this.text = this.contact.Info.replaceAll("{__NEW_LINE__}", "<br>").replaceAll("{__DOUBLE_SPACE__}", "&nbsp;&nbsp;");
				}
			}
		},
	},
	methods: {
		onInput(value: string){
			let regex = /style="(.*?)"/gm;
			value = value.replace(regex, "");
			//value = value.replace(/(?:\r\n)/g, "<br>");
			value = value.replaceAll(/<\/?span[^>]*>/g, "");
			value = value.replaceAll("<blockquote >", "<blockquote>");
			value = value.replaceAll("<br>", "{__NEW_LINE__}");
			value = value.replaceAll("<br >", "{__NEW_LINE__}");
			value = value.replaceAll("<div>", "{__NEW_LINE__}");
			value = value.replaceAll("</div>", "");
			value = value.replaceAll("&nbsp;&nbsp;", "{__DOUBLE_SPACE__}");
			this.text = value;
			this.contact.Info = value;
		},
	},
	created(){
		this.text = this.contact.Info;
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
